import {
  AddExerciseOrBlock,
  InsertRootExerciseButton,
  InsertWorkoutItem,
} from "src/workouts/AddExerciseOrBlock";
import { type RenderInsert } from "src/workouts/BaseWorkoutItemsList";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";

export function WorkoutItemsInsert(args: RenderInsert) {
  const workoutItemsPermission = useWorkoutPermissions();

  if (!workoutItemsPermission.canEditItems) {
    return null;
  }

  if (args.kind === "root") {
    if (!workoutItemsPermission.canAddRootItems && args.parentId === null) {
      return null;
    }

    if (args.parentId !== null) {
      return <InsertRootExerciseButton parentId={args.parentId} />;
    }

    return <AddExerciseOrBlock parentId={args.parentId} />;
  }

  return (
    <InsertWorkoutItem
      key={`insert-${args.itemId}`}
      index={args.index}
      parentId={args.parentId}
      previousItemId={args.previousItemId}
      itemId={args.itemId}
    />
  );
}
